import { inject, reactive } from 'vue';

const APP_CONFIG_SYMBOL = Symbol('appConfig');

export function createAppConfig(locale = 'en', vendor = null) {
    const config = reactive({
        locale,
        vendor,
        // Add other global config properties here
        // Example:
        // apiBaseUrl: import.meta.env.VITE_API_URL,
        // environment: import.meta.env.VITE_APP_ENV,
    });

    return {
        install(app) {
            app.provide(APP_CONFIG_SYMBOL, config);
        },
        config,
    };
}

export function useAppConfig() {
    const config = inject(APP_CONFIG_SYMBOL);

    if (!config) {
        throw new Error('App config not provided! Make sure to call app.use(appConfig) before using useAppConfig');
    }

    return config;
}
